<template>
  <qx-card-form title="新增配件类型">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="accessoryModel" slot-scope="prop">

        <section
            class="salary-item-box"
            v-for="(item, index) in dynamicValidateForm"
            :key="index"
            :style="{'margin-bottom':dynamicValidateForm.length>1?'20px':0}"
        >
          <el-input
              style="width: 240px"
              class="inputBox"
              v-model="item.accessoryModel"
              :placeholder="$route.query.id?'请输入型号':'请输入型号，点击+可添加多个型号'"

          >
          </el-input>
          <i
              class="el-icon-error delBtn cur"
              v-if="index === dynamicValidateForm.length - 1 && index !== 0"
              @click="del('dynamicValidateForm')"
          />
          <div
              class="add-item-Btn"
              @click="addAccessoryModel"
                v-if="index===dynamicValidateForm.length-1 && !$route.query.id"
          >
            +
          </div>
        </section>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      dynamicValidateForm: [{
        accessoryModel: '',
      }],
      baseForm: {
        form: [
          {
            label: '配件名称',
            value: 'accessoryName',
            type: 'input',
            placeholder: '请输入入库配件名称',
          },
          {
            label: '型号',
            value: 'accessoryModel',
            slot: true,
          },
          {
            label: '计量单位',
            value: 'unit',
            type: 'input',
            placeholder: '请输入数量单位，例如个、吨、升等',
          },
          {
            label: '备注',
            value: 'remarks',
            type: 'input',
            placeholder: '请输入备注信息',
          },

        ],
        rules: {
          accessoryName: [ // 配件名称
            { required: true, message: '请输入入库配件名称', trigger: 'blur' },
          ],
          unit: [ // 计量单位
            { required: true, message: '请输入计量单位', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    addAccessoryModel () { // 增加配件型号
      this.dynamicValidateForm.push({
        accessoryModel: '',
      });
    },
    del () { // 删除配件型号
      this.dynamicValidateForm.splice(this.dynamicValidateForm.length - 1, 1);
    },
    async handleSubData (cache) {

      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // let accessoryModelStr = '';
        // this.dynamicValidateForm.forEach((item, index) => {
        //   if (index === this.dynamicValidateForm.length - 1) {
        //     accessoryModelStr += item.accessoryModel;
        //   } else {
        //
        //     accessoryModelStr += item.accessoryModel + ',';
        //   }
        // });
        formData.accessoryModel = JSON.stringify(this.dynamicValidateForm);
        if (this.$route.query.id) {
          formData.update = true;
        }
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      res.accessoryModel = JSON.parse(res.accessoryModel);
      return res;
    },
    async sub () {
      let formData = await this.handleSubData();
      return formData;
    },

    async init (data = {}) {
      this.$refs.baseForm.reset();
      this.dynamicValidateForm = data.accessoryModel || [{
        accessoryModel: '',
      }];
      if (typeof data.accessoryModel !== 'string') {
        this.dynamicValidateForm = this.dynamicValidateForm.map((item) => ({
          accessoryModel: item.accessoryModel,
        }));
      } else {
        this.dynamicValidateForm = [{
          accessoryModel: data.accessoryModel,
        }];
      }
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
.delBtn {
  font-size: 16px;
  margin-left: 16px;
  color: #999;
}


.salary-item-box {
  display: flex;
  align-items: center;
  //margin-bottom: 16px;

  .add-item-Btn{
    margin-left: 16px;
    font-size: 26px;
    cursor: pointer;
  }
}
</style>
